import script from "./BaseSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./BaseSwitcher.vue?vue&type=style&index=0&id=3af30c10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af30c10"]])

export default __exports__